const demoData = {
    createdBy : 1
}

export default demoData;